import { render, staticRenderFns } from "./meeting-view.vue?vue&type=template&id=2b37a554&"
import script from "./meeting-view.vue?vue&type=script&lang=js&"
export * from "./meeting-view.vue?vue&type=script&lang=js&"
import style0 from "./meeting-view.vue?vue&type=style&index=0&id=2b37a554&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports